module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/gallery7-2a3f5bd9b563697e60d8db3f21907773.jpg";